import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource, MatSort, MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { ResizedEvent } from "angular-resize-event";
import {
  SearchFilter,
  IFilterResponse,
} from "src/app/infrastructure/iFilter-component";
import { AdmissionSearchItem } from "src/app/model/admission-search-item";
import { AdmissionService } from "src/app/services/admission.service";
import { AuthService } from "src/app/services/auth.service";
import { ConfirmDialogService } from "src/app/services/confirm-dialog.service";
import { MenuService } from "src/app/services/menu.service";
import { PagerControlComponent } from "../../controls/pager/pager-control.component";
import { SearchFilterComponent } from "../../search-filter/search-filter.component";

@Component({
  selector: "app-integrated-reception-admission-search",
  templateUrl: "./integrated-reception-admission-search.component.html",
  styleUrls: ["./integrated-reception-admission-search.component.css"],
})
export class IntegratedReceptionAdmissionSearchComponent {
  loaded: boolean;
  loadingAction: boolean;
  searchFilters: SearchFilter[];
  widthTableExp: number;
  @ViewChild("pager", { static: true }) pager: PagerControlComponent;
  displayedColumns: string[] = [
    "date",
    "patientLasNameFirstName",
    "practiceRegionName",
    "equipmentName",
    "isOverAppointment",
    "physicianLastNameFirstName",
    "entityName",
    "star",
  ];

  dataSource = new MatTableDataSource([]);
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild("searchFilter", { static: false })
  searchFilter: SearchFilterComponent;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private admissionService: AdmissionService,
    private confirmService: ConfirmDialogService,
    private menuService: MenuService,
    private authService: AuthService
  ) {
    this.menuService.setMenuTitle("Admisión", "recepción integrada");
  }

  resizeColumn() {}

  onStartSearch() {}

  async patientAdmission(admissionSearchItem: AdmissionSearchItem) {
    let setSectorEquipment = false;
    const sectorId = this.authService.getSectorId();

    const diff = await this.admissionService.getLateAttentionMinutes(
      admissionSearchItem.MedicalAppointmentId
    );
    let isOk = true;
    if (diff > 0) {
      isOk = await this.confirmService
        .confirm(
          "Recepción",
          "Ya transcurrieron " +
            diff +
            " minutos del horario original. Está seguro de recepcionar?",
          "Sí",
          "No"
        )
        .toPromise();
    }

    if (
      this.authService.canViewOtherCentersReception() &&
      sectorId !== admissionSearchItem.SectorId
    ) {
      setSectorEquipment = await this.confirmService
        .confirm(
          "Recepción",
          "Está por recepcionar un turno de otra sede o sector, Desea continuar?",
          "Sí",
          "No"
        )
        .toPromise();
    }

    if (isOk) {
      if (setSectorEquipment) {
        await this.admissionService.setEquipmentFromUserSector(
          admissionSearchItem.MedicalAppointmentId
        );
      }

      this.router.navigate([
        "integrated-regular-admission",
        admissionSearchItem.MedicalAppointmentId,
        admissionSearchItem.PatientId,
      ]);
    }
  }

  onTableResized(event: ResizedEvent): void {
    this.widthTableExp = event.newWidth - 40;
  }

  onResizing() {}

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loaded = true;
  }

  onEndSearch(response: IFilterResponse<AdmissionSearchItem>) {
    this.pager.setItems(response.items);
    this.searchFilters = response.searchFilters;
  }

  applyFilter() {
    // this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
